import { HourglassEmpty, InboxOutlined, RequestQuote, Send } from '@mui/icons-material';
import { Alert, Box, Link, Paper, Typography } from '@mui/material';
import { EmptyState } from './EmptyState';
import { IndicacaoButton } from './IndicacaoButton';
import { SectionHeader } from './SectionHeader';

interface SolicitacaoCtaProps {
	valorPendente: string;
	podeSolicitar: boolean;
	solicitando: boolean;
	temPendente: boolean;
	statusSolicitacao?: string | null;
	onSolicitar: () => void;
}

export function SolicitacaoCta({
	valorPendente,
	podeSolicitar,
	solicitando,
	temPendente,
	statusSolicitacao,
	onSolicitar,
}: SolicitacaoCtaProps) {
	return (
		<Paper
			elevation={0}
			sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 3, border: '1px solid #f1f5f9', height: '100%' }}
		>
			<SectionHeader
				icon={<RequestQuote />}
				titulo="Solicitação de valor pendente"
				descricao="Peça a disponibilização do saldo pendente. Um administrador analisa o pedido."
			/>
			<Box mt={2.5}>
				{!temPendente ? (
					<EmptyState
						icon={<InboxOutlined />}
						texto="Não há valor pendente para solicitar no momento."
					/>
				) : (
					<Box
						sx={{
							p: 2,
							borderRadius: 2.5,
							border: '1px solid #f1f5f9',
							bgcolor: '#f8fafc',
						}}
					>
						<Box display="flex" alignItems="center" gap={1} mb={0.75}>
							<HourglassEmpty sx={{ fontSize: 18, color: 'rgb(220, 38, 38)' }} />
							<Typography
								fontSize="0.7rem"
								fontWeight={700}
								letterSpacing="0.06em"
								textTransform="uppercase"
								color="text.secondary"
							>
								Valor disponível para saque
							</Typography>
						</Box>
						<Typography fontWeight={900} fontSize="1.6rem" letterSpacing={-1} mb={2}>
							{valorPendente}
						</Typography>
						{podeSolicitar ? (
							<IndicacaoButton
								label={solicitando ? 'Solicitando...' : 'Solicitar disponibilização'}
								icon={<Send />}
								loading={solicitando}
								onClick={onSolicitar}
								fullWidth
							/>
						) : (
							<Typography fontSize="0.85rem" color="text.secondary">
								{statusSolicitacao === 'SOLICITADA'
									? 'Há uma solicitação em análise. Aguarde a decisão do administrador.'
									: 'Não é possível solicitar neste momento.'}
							</Typography>
						)}
					</Box>
				)}
				<Alert severity="info" sx={{ mt: 2, borderRadius: 2 }}>
					Seu saque será processado após a conclusão do mês vigente e a validação do nosso
					setor financeiro. Qualquer dúvida, fale com a gente em{' '}
					<Link href="mailto:suporte@canaldorepasse.com.br" fontWeight={700}>
						suporte@canaldorepasse.com.br
					</Link>
					.
				</Alert>
			</Box>
		</Paper>
	);
}
